import log from '../whisper';
import { defaultFilteredDomains, defaultConfigs } from '../defaults';
/**
 * Check if URL should be excluded. If no
 * filter URLs are specified in the masquerade config,
 * will check against default filter URLs
 */
export function shouldExcludeUrl(url, filterDomains) {
    if (filterDomains === void 0) { filterDomains = defaultFilteredDomains; }
    if (filterDomains.some(function (x) { return url === null || url === void 0 ? void 0 : url.includes(x); })) {
        log.warn({ message: "Filtered url " + url, once: true });
        return true;
    }
    return false;
}
/**
 * Allows users to omit data for an entire domain.
 * If a URL is filtered by domain specification, *all* data will be scrubbed.
 */
export function excludesUrls(config) {
    if (config === void 0) { config = defaultConfigs; }
    return function (fn) { return function (data) {
        var url = data.url;
        if (shouldExcludeUrl(url, config.filterDomains))
            return null;
        return fn(data);
    }; };
}
export function excludesMimeTypes(_a) {
    var excludedMimeTypes = _a.excludedMimeTypes;
    return function (fn) { return function (data) {
        var mType = data.headers['Content-Type'];
        // Content-Type headers are in the format: <Mime Type>;<Char Set>
        if (mType !== undefined &&
            excludedMimeTypes.includes(mType.split(';')[0])) {
            return null;
        }
        return fn(data);
    }; };
}
/**
 * Allows users to ignore masking a specific domain (LLEs for example).
 * If a domain is ignored, *nothing* will be scrubbed.
 */
export function filtersDomains(_a) {
    var ignoredDomains = _a.ignoredDomains;
    return function (fn) { return function (data) {
        var url = data.url;
        if (ignoredDomains.some(function (x) { return url === null || url === void 0 ? void 0 : url.startsWith(x); })) {
            log.warn({ message: "Masking ignored for " + data.url, once: true });
            return data;
        }
        return fn(data);
    }; };
}
/**
 * Allows users to skip scrubbing for an entire method.
 * If the network data's method is one of the ones provided, *nothing* will be
 * scrubbed.
 */
export function filtersMethods(methods) {
    return function (fn) { return function (data) {
        return methods.includes(data.method) ? data : fn(data);
    }; };
}
//# sourceMappingURL=filter.js.map